import { loadScript, releaseScript } from '../../../browser/ScriptLoader';
import { TIKTOK_PIXEL_SCRIPT_SRC, type TikTokTtq } from './types';

type WindowWithTtq = Window & {
  ttq?: TikTokTtq;
  TiktokAnalyticsObject?: string;
};

function getWindow(): WindowWithTtq | null {
  return typeof window !== 'undefined' ? (window as WindowWithTtq) : null;
}

function ensureTtqStub(): TikTokTtq {
  const win = getWindow();
  if (!win) throw new Error('[TikTokScriptLoader] window unavailable');
  if (win.ttq) return win.ttq;

  const ttq = {
    load() {},
    page() {},
    track() {},
  } as TikTokTtq;

  win.TiktokAnalyticsObject = 'ttq';
  win.ttq = ttq;
  return ttq;
}

export class TikTokScriptLoader {
  private loaded = false;

  async load(timeoutMs = 10_000): Promise<TikTokTtq> {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      throw new Error('[TikTokScriptLoader] Browser APIs unavailable');
    }

    const ttq = ensureTtqStub();
    if (this.loaded) return ttq;

    await loadScript({
      src: TIKTOK_PIXEL_SCRIPT_SRC,
      id: 'pixel-v2-tiktok-analytics',
      timeoutMs,
    });

    this.loaded = true;
    return getWindow()?.ttq ?? ttq;
  }

  release(): void {
    releaseScript(TIKTOK_PIXEL_SCRIPT_SRC);
  }
}
